<div class="product-requests">
  <div class="layout-switcher">
    <layout-switcher></layout-switcher>
  </div>
  <div class="board">
    <product-request-kanban></product-request-kanban>
  </div>
</div>
